import { Text } from 'pcln-design-system'
import { Gps } from 'pcln-icons'
import analytics from '@/shared-utils/analytics'
import useBootstrapData from '@/hooks/useBootstrapData'
import { type CurrentLocationMachineState } from '../../../machines/currentLocationMachine'
import DropdownItem from './DropdownItem'

function getErrorName(code: number): string {
  switch (code) {
    case 1:
      return 'PERMISSION_DENIED'
    case 2:
      return 'POSITION_UNAVAILABLE'
    case 3:
      return 'TIMEOUT'
    default:
      return 'UNKNOWN_ERROR'
  }
}

export const renderDisplayText = (
  current: CurrentLocationMachineState,
  cguid?: string
) => {
  if (current.matches('pending')) {
    return 'Locating...'
  }

  if (current.matches('rejected')) {
    const { error, position } = current.context

    if (error instanceof GeolocationPositionError) {
      const lat = position?.coords?.latitude
      const lon = position?.coords?.longitude
      analytics.logError({
        message: 'Geolocation - getCurrentPosition failed',
        errorMessage: error.message,
        errorCode: error.code,
        errorName: getErrorName(error.code),
        ...(cguid ? { cguid } : {}),
        ...(lat !== undefined && lon !== undefined ? { lat, lon } : {})
      })

      switch (error.code) {
        case error.PERMISSION_DENIED:
          return 'Location access is off. Update browser settings to try again.'
        case error.POSITION_UNAVAILABLE:
          return 'Location Unavailable. Please check your connection or try again.'
        case error.TIMEOUT:
          return 'Location Request Timed Out. Try Again.'
        default:
          return 'Unexpected Location Error. Please try again.'
      }
    }

    return 'Location Sharing Disabled'
  }

  return 'Use Current Location'
}

type RenderCurrentLocationProps = {
  handleRequestCurrentLocationClick?: () => void
  current: CurrentLocationMachineState
}

function RenderCurrentLocation({
  handleRequestCurrentLocationClick,
  current
}: RenderCurrentLocationProps) {
  const {
    webstats: { clientGUID: cguid }
  } = useBootstrapData()
  return (
    <DropdownItem
      {...(handleRequestCurrentLocationClick
        ? { onMouseDown: handleRequestCurrentLocationClick }
        : {})}
      mb={2}
    >
      <Gps color="primary" mx={2} size={24} />
      <Text textStyle="subheading5" py={2} mx={2}>
        {renderDisplayText(current, cguid)}
      </Text>
    </DropdownItem>
  )
}

export default RenderCurrentLocation
